import type {
    PathwayCardContent,
    PathwayTerms,
} from '../../../../configuration/shared';

export const resolveSubHeading = (
    content: PathwayCardContent,
    terms: PathwayTerms | null
): string => {
    if (!terms?.savingsCard) return content.subHeading ?? '';
    if (
        terms.savingsCard.insuranceRequirement === 'ANY_COMMERCIAL' &&
        content.subHeadingCommercialCard
    ) {
        return content.subHeadingCommercialCard;
    }
    return content.subHeadingWithCard ?? content.subHeading ?? '';
};
